var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconSell(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0-2h20v20H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M10 11.414L5.293 6.707a.999.999 0 1 1 1.414-1.414L9 7.586V1a1 1 0 0 1 2 0v6.586l2.293-2.293a.999.999 0 1 1 1.414 1.414L10 11.414zm9.654-3.17a1 1 0 0 1 .103 1.41L14.275 16H5.718L.243 9.662a1 1 0 0 1 1.514-1.307L6.633 14h6.727l4.883-5.654a1 1 0 0 1 1.41-.103z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSell);
export default __webpack_public_path__ + "static/media/icon-sell.4033b7340ce00599af49060826a2f319.svg";
export { ForwardRef as ReactComponent };